function calculateExpectedScore(
  playerElo: number,
  opponentElo: number,
): number {
  return 1 / (1 + 10 ** ((opponentElo - playerElo) / 400));
}

export function calculateElo(
  winnerElo: number,
  loserElo: number,
): { updatedWinnerElo: number; updatedLoserElo: number; eloGain: number } {
  const winnerExpected = calculateExpectedScore(winnerElo, loserElo);
  const loserExpected = calculateExpectedScore(loserElo, winnerElo);

  const K = 32;

  const updatedWinnerElo = Number.isNaN(winnerExpected)
    ? winnerElo
    : Math.round(winnerElo + K * (1 - winnerExpected));

  const updatedLoserElo = Number.isNaN(loserExpected)
    ? loserElo
    : Math.round(loserElo + K * (0 - loserExpected));

  const eloGain = updatedWinnerElo - winnerElo;

  return { updatedWinnerElo, updatedLoserElo, eloGain };
}
